import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./HCarousel.scss";
import Icon from "../Icon";
import PropTypes from "prop-types";

export const HCarousel = ({ slides }) => {
  const [activeIx, setActiveIx] = useState(0);
  const [fading, setFading] = useState(false);
  const [pauseTimer, setPauseTimer] = useState(null);

  const timer = useRef();

  useEffect(() => {
    timer.current = setInterval(() => {
      if (!pauseTimer) {
        setFading(true);
        setActiveIx((prev) => (prev + 1) % slides.length);
      }
    }, 5000);
    return () => {
      clearInterval(timer.current);
    };
  });

  useEffect(() => {
    if (fading) {
      setTimeout(() => setFading(false), 300);
    }
  }, [fading]);

  const leftOffset = (() => {
    const carouselEl = document.querySelector(".hireart-ds-carousel");
    return carouselEl ? carouselEl.parentElement.offsetLeft : 0;
  })();

  return (
    <section
      className="hireart-ds-carousel"
      style={{ marginLeft: `-${leftOffset}px` }}
    >
      <section className="hireart-ds-carousel-content">
        <section className="hireart-ds-carousel-img-window">
          <section
            className="hireart-ds-carousel-img-canvas"
            style={{
              marginLeft: `-${activeIx * 100}vw`,
              opacity: `${fading ? 0.8 : 1}`,
            }}
          >
            {slides.map(({ title, illustration, background }, i) => {
              return (
                <section
                  className={`hireart-ds-carousel-img-slide  ${
                    activeIx === i && "active"
                  }`}
                  style={{
                    left: `${activeIx * 100}vw`,
                    background: `linear-gradient(0deg, rgba(255, 255, 255, 0.34), rgba(255, 255, 255, 0.34)), linear-gradient(9.74deg, ${background[0]} 3.5%, ${background[1]} 98.33%)`,
                  }}
                  key={title}
                >
                  <span style={{ opacity: `${fading ? 0 : 1}` }}>
                    {illustration}
                  </span>
                </section>
              );
            })}
          </section>
        </section>

        <section
          className="hireart-ds-carousel-copy-wrapper"
          onMouseEnter={() => setPauseTimer(true)}
          onMouseLeave={() => setPauseTimer(false)}
        >
          {slides.map(
            (
              { title, description, primary, background, illustration, url },
              i
            ) => {
              return (
                <section
                  className={`hireart-ds-carousel-copy-slide ${
                    activeIx === i && "active"
                  }`}
                  style={{
                    borderTopColor: `${primary}`,
                  }}
                  onMouseEnter={() => {
                    setActiveIx(i);
                    setFading(true);
                  }}
                >
                  <h3>{title}</h3>
                  <div>
                    <div className="hireart-ds-carousel-description">
                      {description}
                    </div>
                    {Boolean(url) && (
                      <Link to={url} className="hireart-ds-carousel-learn-more">
                        Learn more <Icon type="arrow_forward" size="md" />
                      </Link>
                    )}
                  </div>
                  <section
                    className={`hireart-ds-carousel-copy-mobile-img`}
                    style={{
                      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.34), rgba(255, 255, 255, 0.34)), linear-gradient(9.74deg, ${background[0]} 3.5%, ${background[1]} 98.33%)`,
                    }}
                  >
                    {illustration}
                  </section>
                </section>
              );
            }
          )}
        </section>
      </section>
    </section>
  );
};

HCarousel.propTypes = {
  slides: PropTypes.array,
};

